import { createElement as _createElement } from "react";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import Div from '@hellodarwin/core/lib/components/common/div';
import { useTheme } from 'styled-components';
import SectionState from '../../common/SectionState';
import StatisticsContent from './StatisticsContent';
import { StatisticColumnsContainer } from './styles';
import { useComponent } from '../../../hooks/useComponent';
const StatisticColumns = ({ componentType, entryId, }) => {
    var _a;
    const statisticColumns = useComponent(entryId, componentType);
    const { stats, backgroundColors } = (_a = statisticColumns === null || statisticColumns === void 0 ? void 0 : statisticColumns.fields) !== null && _a !== void 0 ? _a : {};
    const theme = useTheme();
    const containerProps = {
        styles: {
            content: { padding: 0 },
            container: { marginTop: 0 },
        },
        containerBackgroundColor: theme.colors[backgroundColors !== null && backgroundColors !== void 0 ? backgroundColors : 'grey_1'],
        tablet: {
            noPadding: true,
        },
        cap: theme.caps.xl,
    };
    if (!(stats === null || stats === void 0 ? void 0 : stats.length))
        return _jsx(_Fragment, {});
    return (_jsx(SectionState, { children: _jsx(StatisticColumnsContainer, Object.assign({}, containerProps, { children: _jsx(Div, { flex: "row", align: "stretch", tablet: { flex: 'column' }, children: stats === null || stats === void 0 ? void 0 : stats.map((stat) => {
                    var _a;
                    return (_createElement(StatisticsContent, Object.assign({}, stat.fields, { key: (_a = stat.sys) === null || _a === void 0 ? void 0 : _a.id })));
                }) }) })) }));
};
export default StatisticColumns;
